module.exports = __webpack_public_path__ + "img/5.ebcc8d75.png";